module.exports = __webpack_public_path__ + "static/media/arrow_4.fdbbb944.svg";